<template>
    <div class="dd-m-auth">
        <div class="dd-m-auth__content">
            <h2 class="dd-m-auth__title">Account successfully created</h2>

            <button type="button"
                    v-on:click="closeModal()"
                    class="dd-m-button dd-m-button--default dd-m-button--assertive">
                Entrar
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'auth-register-success',
        mounted() {
        },
        methods: {
            closeModal() {
                PubSub.publish('closeRegisterModal');
                PubSub.publish('updateRegisterStep', {step: 1});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/auth-register-success.vue